<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="视频名称">
                  <el-input style="width: 177px" v-model="queryForm.videoName"></el-input>
              </el-form-item>
<!--              <el-form-item label="视频来源">-->
<!--                  <el-select style="width: 177px" v-model="queryForm.videoLocation" placeholder="请选择视频来源">-->
<!--                      <el-option-->
<!--                          v-for="item in videoLocationList"-->
<!--                          :key="item.value"-->
<!--                          :label="item.value"-->
<!--                          :value="item.key"-->
<!--                      ></el-option>-->
<!--                  </el-select>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduCourseVideoList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduCourseVideo"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEduCourseVideo(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduCourseVideo(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportEduCourseVideoList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshEduCourseVideoList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduCourseVideoList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoName"
        label="视频名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoSize"
        label="视频大小"
        width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="videoLocation"-->
<!--        label="视频来源"-->
<!--        width="180"-->
<!--      >-->
<!--          <template scope="scope">-->
<!--              <span>{{ videoLocationList.find(e=>e.key === scope.row.videoLocation).value }}</span>-->
<!--          </template>-->
<!--      </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoUrl"
        label="视频地址"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoCover"
        label="视频封面"
        width="180"
      >
          <template scope="scope">
              <el-image
                  @click='updateSrcList(scope.row.videoCover)'
                  style='width: 80px; height: 80px'
                  :src='scope.row.videoCover'
                  :preview-src-list='srcList'
              ></el-image>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoSecond"
        label="视频时长"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoTag"
        label="标签"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkEduCourseVideo(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editEduCourseVideo(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEduCourseVideo(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduCourseVideoStates[eduCourseVideoState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="eduCourseVideo"
          ref="eduCourseVideoForm"
          :rules="rules"
          label-width="90px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="视频名称"
            prop="videoName"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="eduCourseVideo.videoName"
              :disabled="eduCourseVideoState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="视频大小"
            prop="videoSize"
            v-if="eduCourseVideoState == 'check'"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="eduCourseVideo.videoSize"
              :disabled="eduCourseVideoState == 'check'"
            ></el-input>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="视频来源"-->
<!--            prop="videoLocation"-->
<!--          >-->
<!--              <el-select :disabled="eduCourseVideoState == 'check'" style="width: 177px" v-model="eduCourseVideo.videoLocation" placeholder="请选择视频来源">-->
<!--                  <el-option-->
<!--                      v-for="item in videoLocationList"-->
<!--                      :label="item.value"-->
<!--                      :value="item.key"-->
<!--                  ></el-option>-->
<!--              </el-select>-->
<!--          </el-form-item>-->
          <el-form-item
            label="视频地址"
            prop="videoUrl"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="eduCourseVideo.videoUrl"-->
<!--              :disabled="eduCourseVideoState == 'check'"-->
<!--            ></el-input>-->
              <div style="width: 177px;display: flex;align-items: center;">
                  <el-input v-model="eduCourseVideo.videoUrl" size="small" :disabled="eduCourseVideoState == 'check'"></el-input>
                  <el-button type="primary" size="small" style="margin-left: 2px;" @click="uploadImages1()" :disabled="eduCourseVideoState == 'check'">上传视频
                      <el-upload action="#" :headers="header" v-show="false" ref="uploads1" class="avatar-uploader" :show-file-list="false"
                                 :http-request="uploadImage1">
                          <el-button type="primary" size="small" class="as1">上传</el-button>
                      </el-upload>
                  </el-button>
              </div>
          </el-form-item>
          <el-form-item
            label="视频时长"
            prop="videoSecond"
            v-if="eduCourseVideoState == 'check'"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="eduCourseVideo.videoSecond"
              :disabled="eduCourseVideoState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="视频标签"
            prop="videoTag"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="eduCourseVideo.videoTag"
              :disabled="eduCourseVideoState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="视频排序"
            prop="sort"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseVideo.sort"-->
<!--              :disabled="eduCourseVideoState == 'check'"-->
<!--            ></el-input>-->
              <el-input-number
                  style="width: 177px"
                  :disabled="eduCourseVideoState == 'check'"
                  v-model="eduCourseVideo.sort"
                  size="small"
                  label=""
                  :min="1"
                  :max="100000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </el-form-item>
            <el-form-item
                label="视频封面"
                prop="videoCover"
            >
                <!--            <el-input-->
                <!--              size="small"-->
                <!--              v-model="eduCourseVideo.videoCover"-->
                <!--              :disabled="eduCourseVideoState == 'check'"-->
                <!--            ></el-input>-->
                <el-upload
                    action=""
                    :disabled="eduCourseVideoState == 'check'"
                    class="avatar-uploader"
                    :show-file-list="false"
                    :http-request="uploadAvatar"
                    style="width: 177px"
                >
                    <img
                        v-if="eduCourseVideo.videoCover"
                        :src="eduCourseVideo.videoCover"
                        class="avatar"
                    />
                    <i
                        v-else
                        class="el-icon-plus avatar-uploader-icon"
                    ></i>
                </el-upload>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduCourseVideoState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_API, UPLOAD_PATH } from '@/utils/constant';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduCourseVideoList();
                    this.getEduCourseVideoList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduCourseVideoList();
                    this.getEduCourseVideoList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     videoName: '', //视频名称
                     videoSize: '', //视频大小
                     videoLocation: '', //视频来源
                     videoUrl: '', //视频地址
                     videoCover: '', //视频封面
                     videoSecond: '', //视频时长
                     videoTag: '', //标签 先按照标签序正排列，再按照sort正序排列
                     sort: '', //排序
                },
                header: {
                    token: localStorage.getItem('token')
                },
                action: UPLOAD_API + UPLOAD_PATH,
                srcList: [''],
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduCourseVideoState: 'add',
                eduCourseVideoStates: {
                    add: '新建视频',
                    check: '查看视频',
                    edit: '修改视频'
                },
                // videoLocationList: [],
                multipleSelection: [],
                eduCourseVideoList: [],
                eduCourseVideo: {
                    id: '', //
                    videoName: '', //视频名称
                    videoSize: '', //视频大小
                    videoLocation: '', //视频来源
                    videoUrl: '', //视频地址
                    videoCover: '', //视频封面
                    videoSecond: '', //视频时长
                    videoTag: '', //标签 先按照标签序正排列，再按照sort正序排列
                    sort: '', //排序
                },
                btnLoading: false,

                rules: {
                    videoName: [{ required: true, message: '视频名称不能为空', trigger: 'blur' }],
                    videoSize: [{ required: true, message: '视频大小不能为空', trigger: 'blur' }],
                    videoLocation: [{ required: true, message: '视频来源不能为空', trigger: 'blur' }],
                    videoUrl: [{ required: true, message: '视频地址不能为空', trigger: 'blur' }],
                    videoCover: [{ required: true, message: '视频封面不能为空', trigger: 'blur' }],
                    videoSecond: [{ required: true, message: '视频时长不能为空', trigger: 'blur' }],
                    videoTag: [{ required: true, message: '标签 先按照标签序正排列，再按照sort正序排列不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getEduCourseVideoList();
            // this.getEnumList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getEnumList(){
                get(`/edu/utils/getEnum?enumType=video_location`).then((res) => {
                    if (res.success) {
                        this.videoLocationList = res.enumList;
                    }
                });
            },
            uploadImages1() {
                this.$refs.uploads1.$el.querySelector(".as1").click()
            },
            uploadImage1(params) {
                const file = params.file;
                const formData = new FormData();
                formData.append('file', file);
                upload('/mpp/file/upload', formData).then((res) => {
                    if (res.success) {
                        this.eduCourseVideo.videoUrl = res.url
                        this.eduCourseVideo.videoCover = res.videoCover
                        this.eduCourseVideo.videoSize = res.videoSize
                        this.eduCourseVideo.videoSecond = res.videoDuration
                    }else{
                        this.$message.error(res.msg)
                    }
                });
            },
            uploadAvatar(params) {
                console.log({ params });
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg'];
                if (!types.includes(file.type)) {
                    this.$message({
                        message: '只能上传图片格式的文件，png.jpg或者jpeg',
                        type: 'error',
                        showClose: true,
                        duration: 2000
                    });
                    return;
                }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(`/mpp/image/upload`, formData).then((res) => {
                    console.log({ res });
                    if (res.success) {
                        this.eduCourseVideo.videoCover = res.url;
                    }
                });
            },
            updateSrcList(src) {
                this.srcList[0] = src;
            },
            resetEduCourseVideoList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduCourseVideoList = [];
            },
            resetDialog() {
                this.eduCourseVideoState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      videoName: '', //视频名称
                      videoSize: '', //视频大小
                      videoLocation: '', //视频来源
                      videoUrl: '', //视频地址
                      videoCover: '', //视频封面
                      videoSecond: '', //视频时长
                      videoTag: '', //标签 先按照标签序正排列，再按照sort正序排列
                      sort: '', //排序
                };
                this.getEduCourseVideoList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduCourseVideo = {
                      id: '', //
                      videoName: '', //视频名称
                      videoSize: '', //视频大小
                      videoLocation: '', //视频来源
                      videoUrl: '', //视频地址
                      videoCover: '', //视频封面
                      videoSecond: '', //视频时长
                      videoTag: '', //标签 先按照标签序正排列，再按照sort正序排列
                      sort: '', //排序
                };
            },
            submitForm() {
                if (this.eduCourseVideoState == 'add') {
                    this.$refs.eduCourseVideoForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/coursevideo/add`,{ ...this.eduCourseVideo }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduCourseVideoList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduCourseVideoState == 'edit') {
                    this.$refs.eduCourseVideoForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/coursevideo/edit`,{ ...this.eduCourseVideo }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduCourseVideoList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduCourseVideo() {
                this.showDialog = true;
                this.eduCourseVideoState = 'add';
            },
            checkEduCourseVideo(eduCourseVideoId) {
                console.log(eduCourseVideoId);
                this.currentEduCourseVideoId = eduCourseVideoId;

                this.getEduCourseVideoById();
                this.showDialog = true;
                this.eduCourseVideoState = 'check';
            },
            editEduCourseVideo(eduCourseVideoId) {
                console.log('eduCourseVideo', eduCourseVideoId);
                if (eduCourseVideoId) {
                    this.currentEduCourseVideoId = eduCourseVideoId;
                    this.getEduCourseVideoById();
                } else {
                    this.eduCourseVideo = { ...this.eduCourseVideo, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduCourseVideoState = 'edit';
            },
            deleteEduCourseVideo(eduCourseVideoId) {
                let ids = '';
                if (eduCourseVideoId) {
                    ids = eduCourseVideoId;
                } else {
                    ids = this.multipleSelection.map((eduCourseVideo) => eduCourseVideo.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/coursevideo/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduCourseVideoList();
                                this.getEduCourseVideoList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduCourseVideoList() {
                this.resetEduCourseVideoList();
                this.getEduCourseVideoList();
            },
            getEduCourseVideoList(query = {}) {
                this.loading = true;
                get(`/edu/coursevideo/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduCourseVideoList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduCourseVideoById() {
                get(`/edu/coursevideo/get`,{ id: this.currentEduCourseVideoId }).then((res) =>{
                    if(res.success){
                      this.eduCourseVideo = { ...this.eduCourseVideo, ...res.eduCourseVideo };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduCourseVideoList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/coursevideo/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/coursevideo/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/coursevideo/importData`,formData);
              this.refreshEduCourseVideoList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduCourseVideoList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduCourseVideoList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 177px;
    height: 177px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 177px;
    height: 177px;
    line-height: 177px;
    text-align: center;
}
.avatar {
    width: 177px;
    height: 177px;
    display: block;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>